import { Suspense, lazy } from "react";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";

// Lazy load page components
const Index = lazy(() => import("./pages/Index"));
const Particulieren = lazy(() => import("./pages/Particulieren"));
const Zakelijk = lazy(() => import("./pages/Zakelijk"));
const Studenten = lazy(() => import("./pages/Studenten"));
const Contact = lazy(() => import("./pages/Contact"));
const Hypotheken = lazy(() => import("./pages/Hypotheken"));
const Serviceabonnement = lazy(() => import("./pages/Serviceabonnement"));
const Schade = lazy(() => import("./pages/Schade"));

const Cookies = lazy(() => import("./pages/Cookies"));
const Disclaimer = lazy(() => import("./pages/Disclaimer"));
const Privacybeleid = lazy(() => import("./pages/Privacybeleid"));
const OverOns = lazy(() => import("./pages/OverOns"));
const AlgemeneVoorwaarden = lazy(() => import("./pages/AlgemeneVoorwaarden"));
const Klachtenregeling = lazy(() => import("./pages/Klachtenregeling"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div></div>}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/particulieren" element={<Particulieren />} />
            <Route path="/zakelijk" element={<Zakelijk />} />
            <Route path="/studenten" element={<Studenten />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/hypotheken" element={<Hypotheken />} />
            <Route path="/serviceabonnement" element={<Serviceabonnement />} />
            <Route path="/schade" element={<Schade />} />
            
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/privacybeleid" element={<Privacybeleid />} />
            <Route path="/over-ons" element={<OverOns />} />
            <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaarden />} />
            <Route path="/klachtenregeling" element={<Klachtenregeling />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
